import { render, staticRenderFns } from "./product.vue?vue&type=template&id=64c02740&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./product.vue?vue&type=style&index=1&id=64c02740&lang=scss&scoped=true&"
import style2 from "./product.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c02740",
  null
  
)

export default component.exports